<mat-sidenav-container class="sidenav-container">
        <mat-sidenav #sidenav class="sidenav" fixedInViewport="false"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [opened]="true">
          <mat-nav-list >
            <a mat-list-item *ngFor="let item of empolyeeTasks" [routerLink]="item.route"> {{item.task}} </a>

          </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content>
          <div >
              <mat-toolbar class="example-toolbar">
                  <mat-toolbar-row>
                    <button mat-icon-button>
                      <mat-icon (click)="sidenav.toggle()">menu</mat-icon>
                    </button>
                    <h1>Traceability</h1>
                  </mat-toolbar-row>
                </mat-toolbar>
            <router-outlet></router-outlet>
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>